export const OPEN_SOURCES = [
  {
    icon:"AirplaneRegular",
    title:"The Little Plane Project",
    info:"A simple 2D game about flying a plane",
    mine:[
      "I added fixed bugs, did refactors, and added new features",
      "like plane instruments, plane sounds, clouds, day-night cycle,",
      "and more! The unmerged PRs include multiplayer stuff, and is",
      "available on my fork if someone is curious."
    ].join(" "),
    dist:{
      main: "https://www.glowstick.me/tlpp",
      fork: "https://little-flight.attaditya.space",
    },
    repo:{
      author: "Glowstick0017",
      name: "Little-Plane-Project",
    },
    fork:{
      author: "Little-Flight",
      name: "little-flight"
    },
    animation: "fly-pulse"
  },
  {
    icon: "BrightStarRegular",
    title: "Iconoir Icon Library",
    info: "A large collection of free to use icons",
    mine: [
      "Contributing for Iconoir - Contribution Guidelines, Landing Pages, ",
      "and Iconoir Preact - which is currently available as ",
      "@attaditya/iconoir-preact on npm.",
    ].join(" "),
    dist: {
      main: "https://www.npmjs.com/package/iconoir",
      fork: "https://www.npmjs.com/package/@attaditya/iconoir-preact",
    },
    repo: {
      author: "iconoir-icons",
      name: "iconoir",
    },
    fork: {
      author: "AttAditya",
      name: "iconoir"
    },
    animation: "jiggle"
  }
];

